function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { getDocument } from './get-document';
import { requestAnimationFrameAsync } from './request-animation-frame-async';
export function getScrollBarWidth() {
  var doc = getDocument();

  if (!doc) {
    return 0;
  }

  var element = createElementWidthScrollBar(doc);
  document.body.appendChild(element);
  var width = element.offsetWidth - element.clientWidth;
  document.body.removeChild(element);
  return width;
}
export function getScrollBarWidthAsync() {
  return _getScrollBarWidthAsync.apply(this, arguments);
}

function _getScrollBarWidthAsync() {
  _getScrollBarWidthAsync = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", requestAnimationFrameAsync(getScrollBarWidth));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getScrollBarWidthAsync.apply(this, arguments);
}

function createElementWidthScrollBar(doc) {
  var element = doc.createElement('div');
  element.style.cssText = "position:absolute;top:-99px;left:-99px;width:99px;height:99px;overflow:scroll;opacity:0;pointer-events:none;";
  return element;
}